<i class="{{cssClass}} {{icon}} {{color}}"></i>
<ng-content></ng-content>
